import React from 'react';
import { Layout } from './Home';
import PageHero from '../components/PageHero';
import RichContent from '../components/RichContent';

const CONTENT = `
## 1. Introduction
These Terms & Conditions ("Terms") govern your access to and use of the website, digital services and communications operated by **Emerald Corporates Limited** ("Emerald", "we", "us", "our") — a company incorporated in England & Wales, Company No. 16120279, registered at Office Gold, Building 7, Floor 5, 566 Chiswick High Road, Chiswick Business Park, London, United Kingdom, W4 5YG.

By accessing or using our website, you agree to be bound by these Terms. If you do not agree, please do not use the site.

## 2. Use of the Website
You may access this website for lawful, non-commercial personal use and for evaluating Emerald's businesses, services and public communications. You agree not to:

- Use the site in any way that breaches applicable local, national or international law
- Transmit unsolicited advertising or promotional material ("spam")
- Knowingly transmit data, send or upload material that contains viruses, worms, trojans, spyware or any other harmful programs
- Attempt to gain unauthorised access to our servers, databases, or any account or system connected to the site
- Reverse-engineer, decompile, disassemble, or otherwise attempt to derive the source code of any software used on the site
- Interfere with the proper working of the site or any transaction being conducted on it

## 3. Intellectual Property
All content on this website — including text, graphics, logos, icons, images, audio clips, video clips, data compilations and software — is the property of Emerald Corporates Limited or its licensors and is protected by international copyright, trademark and other intellectual-property laws.

You may view, download and print pages from the site for your own personal, non-commercial use only. You may not otherwise reproduce, distribute, modify, transmit, republish, or exploit any content without our prior written permission.

## 4. Corporate Communications, Not Investment Advice
Information published on this site — including news, press releases, business-vertical descriptions, market indicators and third-party news feeds — is provided for **general informational purposes only**. It does not constitute:

- Investment, financial, legal, tax or accounting advice
- An offer or solicitation to buy or sell any security, financial instrument or product
- A recommendation to enter into any transaction
- A representation that any particular investment is suitable for you

You should seek independent professional advice before making any financial or business decision based on content published on this website.

## 5. Third-Party Content and Links
Our site displays selected third-party market data (e.g. index and commodity prices) and news headlines curated from public news feeds. Such content is provided "as is" without warranty. Emerald does not endorse, control or guarantee the accuracy or completeness of third-party content, and is not responsible for the availability of external websites or resources linked from our site.

## 6. Accounts, Access Credentials and Employee Portals
Where Emerald provides authenticated access to admin or employee portals, you are responsible for maintaining the confidentiality of your credentials and for all activities that occur under your account. You must notify us immediately of any unauthorised access or use of your account.

## 7. Availability and Changes
We take reasonable steps to ensure the website is available, but we do not guarantee uninterrupted access. We reserve the right to add, modify, suspend or discontinue any part of the website or these Terms at any time without prior notice.

## 8. Limitation of Liability
To the maximum extent permitted by applicable law, Emerald Corporates Limited, its directors, officers, employees and affiliates shall not be liable for any direct, indirect, incidental, consequential, special or punitive damages arising from your access to or inability to access the website, from reliance on any information contained on it, or from any error, omission, interruption, defect or delay in operation or transmission.

## 9. Indemnity
You agree to indemnify and hold Emerald harmless from any claim, loss, liability, expense or damage arising from your breach of these Terms or your misuse of the website.

## 10. Data Protection & Privacy
Our processing of personal data is described in the [Privacy Policy](/privacy). By using the site you acknowledge that policy and consent to the processing described therein.

## 11. Governing Law and Jurisdiction
These Terms shall be governed by and construed in accordance with the **laws of England and Wales**. Any dispute arising out of or in connection with these Terms, or the use of this website, shall be subject to the **exclusive jurisdiction of the courts of England and Wales**.

## 12. Changes to These Terms
We may update these Terms from time to time. The revised version will be posted on this page with the "Last updated" date changed accordingly. Continued use of the site after any change constitutes acceptance of the updated Terms.

## 13. Contact
Questions about these Terms may be sent to **info@emeraldcorporates.com** or by post to our registered office in London.
`;

const TermsPage = () => {
  return (
    <Layout>
      <PageHero
        eyebrow="Legal"
        title="Terms & Conditions"
        description="Please read these Terms carefully before using the Emerald Corporates website and digital services."
        image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1600&q=80"
      />
      <section className="bg-[#e2ede6] py-16 lg:py-24" data-testid="terms-page">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-white rounded-2xl border border-black/5 p-6 lg:p-10 shadow-sm">
            <p className="text-xs text-[#0b1a2e]/50 mb-6">
              Last updated: February 2026
            </p>
            <RichContent text={CONTENT} />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TermsPage;
